import { gql } from "@apollo/client";

export const PUBLIC_QR_LOOKUP_QUERY = gql`
  query PublicQrLookup($token: String!) {
    publicQrLookup(token: $token) {
      status
      resourceType
      asset {
        id
        name
        status
        serialNumber
        description
        locationPath
        locationName
        specifications
        productName
        productCategory
        productType
        manufacturer
        instructions {
          question
          answer
          source
        }
      }
      location {
        id
        name
        locationTypeName
        parentPath
        buildingName
        address
        city
        state
        zipcode
        country
        description
      }
      emergencyContacts {
        label
        name
        phone
        email
      }
    }
  }
`;

export const QR_ACTIVE_ASSET_COUNT_QUERY = gql`
  query QrActiveAssetCount($filter: QrAssetBulkFilterInput) {
    qrActiveAssetCount(filter: $filter)
  }
`;

export const QR_LOCATION_SUBTREE_COUNT_QUERY = gql`
  query QrLocationSubtreeCount($filter: QrLocationSubtreeFilterInput!) {
    qrLocationSubtreeCount(filter: $filter)
  }
`;
